enum EFormType {
  STICKER = 'sticker',
  DISCOUNT = 'discount',
  PROMO_CODES = 'promoCodes',
  TEXT_PROMOTION = 'textPromotion',
  KIT = 'kit',
}

export default EFormType;
